import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Modal from '@spa/shared/components/Modal';
import Button from '@spa/shared/components/Button';
import { multipleLines } from '@spa/shared/utils/i18next';
import { ActionsWrapper, ContentWrapper, ModalGlobalStyle } from './styles';
import IgnacioValentine from '@spa/shared/svg/inacio-valentine';

const WishlistModal = ({ onClose }) => {
  const { t } = useTranslation('translations');

  const handleSignUp = () => {
    window.location.href = `${process.env.APP_URL}signup?from=property&context=wish-list-modal-offer`;
  };

  const handleLogIn = () => {
    window.location.href = `${process.env.APP_URL}login`;
  };

  return (
    <Modal className="wishlist" title={t('wishlist_modal.title')} onClose={onClose}>
      <ModalGlobalStyle />
      <ContentWrapper>
        <IgnacioValentine />
        <p>{multipleLines(t('wishlist_modal.text'))}</p>
      </ContentWrapper>

      <ActionsWrapper>
        <Button onClick={handleSignUp}>{t('global.labels.sign_up')}</Button>
        <Button className="submit-button--secondary" onClick={handleLogIn}>
          {t('global.labels.log_in')}
        </Button>
      </ActionsWrapper>
    </Modal>
  );
};

WishlistModal.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default WishlistModal;
